import { __module as toPropertyKey } from './_virtual-toPropertyKey.js';
import { __require as require_typeof } from './node_modules-@babel-runtime-helpers-typeof.js';
import { __require as requireToPrimitive } from './node_modules-@babel-runtime-helpers-toPrimitive.js';

var hasRequiredToPropertyKey;

function requireToPropertyKey () {
	if (hasRequiredToPropertyKey) return toPropertyKey.exports;
	hasRequiredToPropertyKey = 1;
	(function (module) {
		var _typeof = require_typeof()["default"];
		var toPrimitive = requireToPrimitive();
		function toPropertyKey(t) {
		  var i = toPrimitive(t, "string");
		  return "symbol" == _typeof(i) ? i : i + "";
		}
		module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (toPropertyKey));
	return toPropertyKey.exports;
}

export { requireToPropertyKey as __require };
//# sourceMappingURL=node_modules-@babel-runtime-helpers-toPropertyKey.js.map
